import React from "react";
import { Home } from "lucide-react";

const Breadcrumb = () => {
  return (
    <nav aria-label="Breadcrumb" className="overflow-x-auto">
      <ol className="flex w-max overflow-hidden rounded-md border border-slate-200 text-gray-600">
        <li className="flex items-center">
          <button
            type="button"
            className="flex h-10 items-center gap-2 bg-slate-50 px-4 text-xs font-semibold transition hover:text-purple-700"
          >
            <Home className="h-4 w-4" aria-hidden="true" />
            All
          </button>
        </li>

        <li className="relative flex items-center">
          <span className="absolute inset-y-0 -start-px h-10 w-4 bg-slate-50 [clip-path:_polygon(0_0,_0%_100%,_100%_50%)] rtl:rotate-180" />

          <button
            type="button"
            className="flex h-10 items-center bg-white pe-4 ps-8 text-xs font-semibold transition hover:text-purple-700"
          >
            Weekly Prediction
          </button>
        </li>

        <li className="relative flex items-center">
          <span className="absolute inset-y-0 -start-px h-10 w-4 bg-white [clip-path:_polygon(0_0,_0%_100%,_100%_50%)] rtl:rotate-180" />

          <button
            type="button"
            className="flex h-10 items-center bg-white pe-4 ps-8 text-xs font-semibold transition hover:text-purple-700"
          >
            Exam Questions
          </button>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
